module.exports = __webpack_public_path__ + "static/media/face.6caa6861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/face.png
// module id = 40
// module chunks = 0